import React, { useEffect } from 'react'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import Button from '../../../../atoms/Button/Button'
import useTrans from '../../../../../hooks/useTrans'
import { trackingRegistrazioneFunnel } from '../../../../../utils/gtm'

const DatiPersonali = ({ step, setStep, props }) => {
  const t = useTrans()
  return (
    <div className="step-registrazione">
      <div className="step-registrazione__fieldsets">
        <FormField
          label={t('Nome') + ' *'}
          status={
            props.touched.utente?.nome && props.errors.utente?.nome
              ? 'error'
              : props.touched.utente?.nome && 'success'
          }
          errorMessage={props.errors?.utente?.nome}
          id={"dati-personali-nome"}
        >
          <FormInput
            value={props.values.utente.nome}
            onBlur={props.handleBlur('utente.nome')}
            onChange={props.handleChange('utente.nome')}
            id={"dati-personali-nome"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('Cognome') + ' *'}
          status={
            props.touched.utente?.cognome && props.errors.utente?.cognome
              ? 'error'
              : props.touched.utente?.cognome && 'success'
          }
          errorMessage={props.errors?.utente?.cognome}
          id={"dati-personali-cognome"}
        >
          <FormInput
            value={props.values.utente.cognome}
            onBlur={props.handleBlur('utente.cognome')}
            onChange={props.handleChange('utente.cognome')}
            id={"dati-personali-cognome"}
          ></FormInput>
        </FormField>
        <FormField
          label="e-mail *"
          status={
            props.touched.utente?.email && props.errors.utente?.email
              ? 'error'
              : props.touched.utente?.email && 'success'
          }
          errorMessage={props.errors?.utente?.email}
          id={"dati-personali-email"}
        >
          <FormInput
            value={props.values.utente.email}
            onBlur={props.handleBlur('utente.email')}
            onChange={props.handleChange('utente.email')}
            id={"dati-personali-email"}
          ></FormInput>
        </FormField>
        <FormField
          label={t('telefono') + ' *'}
          status={
            props.touched.utente?.telefono && props.errors.utente?.telefono
              ? 'error'
              : props.touched.utente?.telefono && 'success'
          }
          errorMessage={props.errors?.utente?.telefono}
          id={"dati-personali-telefono"}
        >
          <FormInput
            value={props.values.utente.telefono}
            onBlur={props.handleBlur('utente.telefono')}
            onChange={props.handleChange('utente.telefono')}
            id={"dati-personali-email"}
          ></FormInput>
        </FormField>
      </div>
      <p className="step-registrazione__legend">*{t('Campi obbligatori')}</p>
      <Button
        disabled={props.errors.utente || !props.dirty}
        label={t('Conferma dati')}
        variant="primary"
        size="medium"
        onClick={() => {
          trackingRegistrazioneFunnel(1)
          setStep(step + 1)
        }}
      />
    </div>
  )
}

export default DatiPersonali
